import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function WeeklyUserEventsChart({ data }) {
  return (
    <div className="wrapper">
      <header>
        <h2>Weekly Users Events </h2>
      </header>
      <ResponsiveContainer height={300}>
        <BarChart
          width="100%"
          height="100%"
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barSize={20}
        >
          <XAxis
            dataKey="key"
            scale="point"
            padding={{ left: 10, right: 10 }}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <CartesianGrid strokeDasharray="3 3" />
          <Bar
            dataKey="value"
            fill="#ffc327"
            background={{ fill: "#fff7e1" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default WeeklyUserEventsChart;
